<template>
  <component v-bind:is="icon" />
</template>

<script>
import AccountIcon from '@/assets/icons/AccountIcon'
import AgentBrokerIcon from '@/assets/icons/AgentBrokerIcon'
import AttorneysIcon from '@/assets/icons/AttorneysIcon'
import BillingHistoryIcon from '@/assets/icons/BillingHistoryIcon'
import BuildersRiskIcon from '@/assets/icons/BuildersRiskIcon'
import CertificateRequestIcon from '@/assets/icons/CertificateRequestIcon'
import ClaimsIcon from '@/assets/icons/ClaimsIcon'
import CommunicationsIcon from '@/assets/icons/CommunicationsIcon'
import DownloadIcon from '@/assets/icons/DownloadIcon'
import PolicyAdminIcon from '@/assets/icons/PolicyAdminIcon'
import RenewalDashboardIcon from '@/assets/icons/RenewalDashboardIcon'
import RiskManagementIcon from '@/assets/icons/RiskManagementIcon'
import SchedulesIcon from '@/assets/icons/SchedulesIcon'
import UpdateFirmIcon from '@/assets/icons/UpdateFirmIcon'

export default {
  components: {
    AccountIcon,
    AgentBrokerIcon,
    AttorneysIcon,
    BillingHistoryIcon,
    BuildersRiskIcon,
    CertificateRequestIcon,
    ClaimsIcon,
    CommunicationsIcon,
    DownloadIcon,
    PolicyAdminIcon,
    RenewalDashboardIcon,
    RiskManagementIcon,
    SchedulesIcon,
    UpdateFirmIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
}
</script>
